import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "pt", setLang: () => {}, t: {} });

export const useLang = () => useContext(LangContext);

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
